import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";
import { useSearchContext } from "../../contexts";
import { PlatformChooser } from "../PlatformChooser";
import { useTranslation } from "react-i18next";

interface PlatformChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const PlatformChooserDropdown: React.FC<PlatformChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Platforms")}
      counter={state.draftFilters.platforms.value.length}
      isExclude ={state.draftFilters.platforms.exclude}
      onOpenChange={onOpenChange}
    >
      <PlatformChooser />
    </DropdownFilter>
  )
};
